import { ArrowUp, Sparkles, Square } from 'lucide-react'

// The docked ask-bar (Block F) — the authoring channel, present at the bottom of
// the Mina dashboards workspace. A centered, rounded, shadowed pill (not a full-bleed
// form). Ask in Swedish; the answer renders as the same card type and is pinnable.
// The bar never produces numbers itself — it hands the question to the grounded loop.
export function AskBar({
  value,
  setValue,
  busy,
  onAsk,
  onStop,
  dashboardName,
}: {
  value: string
  setValue: (v: string) => void
  busy: boolean
  onAsk: (q: string) => void
  onStop: () => void
  dashboardName?: string
}) {
  return (
    <div className="composer" role="search">
      <form
        className="askbar"
        onSubmit={(e) => {
          e.preventDefault()
          onAsk(value)
        }}
      >
        <Sparkles size={18} className="askbar-spark" aria-hidden />
        <input
          className="askbar-input"
          type="text"
          placeholder={dashboardName ? `Ask a question to build ${dashboardName}` : 'Ask your data — e.g. the most popular flavour in Stockholm'}
          value={value}
          autoComplete="off"
          onChange={(e) => setValue(e.target.value)}
          aria-label="Ask a question"
        />
        {busy ? (
          <button className="askbar-send" type="button" onClick={onStop} aria-label="Stop question" title="Stop question">
            <Square size={15} />
          </button>
        ) : (
          <button className="askbar-send" type="submit" disabled={!value.trim()} aria-label="Ask">
            <ArrowUp size={18} />
          </button>
        )}
      </form>
    </div>
  )
}
